/**
 * Entry application component used to compose providers and render Routes.
 * */

import React, {useEffect} from "react";
import {Provider} from "react-redux";
import {BrowserRouter, useLocation} from "react-router-dom";
import {PersistGate} from "redux-persist/integration/react";
import {Routes} from "../app/Routes";
import {LayoutSplashScreen, MaterialThemeProvider} from "../_metronic/layout";
import i18next from "i18next";
import lang_en from "./../_metronic/i18n/messages/en.json"
import lang_fa from "./../_metronic/i18n/messages/fa.json"
import lang_ru from "./../_metronic/i18n/messages/ru.json"
import {I18nextProvider, useTranslation} from "react-i18next";
// import detector from "i18next-browser-languagedetector";

const localSavedLang = localStorage.getItem("lang") ? localStorage.getItem("lang") : "fa"

export default function App({store, persistor, basename}) {
	useEffect(() => {
		i18next
			// .use(detector)
			.init({
			interpolation: {escapeValue: false},
			fallbackLng: "en",
			lng: localSavedLang,                              // language to use
			resources: {
				en: {
					common: lang_en               // 'common' is our custom namespace
				},
				fa: {
					common: lang_fa
				},
				ru: {
					common: lang_ru
				}
			}
		});
	}, [])

	const LangDigit = ({children}) => {
		const {t} = useTranslation("common");

		function useQuery() {
			return new URLSearchParams(useLocation().search);
		}

		let query = useQuery();
    const qLng = query.get("lang");

		useEffect(() => {
			if (qLng) {
				i18next.changeLanguage(qLng);
				if (typeof window !== "undefined") window.localStorage.setItem("lang", qLng);
			}
		}, [qLng])

		return (
			<div className={`h-100 ${t("lang") !== "fa" && t("lang") !== "af" && t("lang") !== "ar" ? "english-digit" : ""}`}>
				{children}
			</div>
		);
	};

	return (
		/* Provide Redux store */
		<Provider store={store}>
			{/* Asynchronously persist redux stores and show `SplashScreen` while it's loading. */}
			<PersistGate persistor={persistor} loading={<LayoutSplashScreen/>}>
				{/* Add high level `Suspense` in case if was not handled inside the React tree. */}
				<React.Suspense fallback={<LayoutSplashScreen/>}>
					{/* Override `basename` (e.g: `homepage` in `package.json`) */}
					<BrowserRouter basename={basename}>
						{/*This library only returns the location that has been active before the recent location change in the current window lifetime.*/}
						<MaterialThemeProvider>
							{/* Provide `react-intl` context synchronized with Redux state.  */}
							<I18nextProvider i18n={i18next}>
								<LangDigit>
									{/* Render routes with provided `Layout`. */}
									<Routes/>
								</LangDigit>
							</I18nextProvider>
						</MaterialThemeProvider>
					</BrowserRouter>
				</React.Suspense>
			</PersistGate>
		</Provider>
	);
}
